<div class="bf-pricing">

  <app-hero></app-hero>


  <app-price-list></app-price-list>

</div>
